import { useSelector } from 'react-redux';

import { SidebarNotificationBadge } from 'src/components/sidebar/sidebar-items/SidebarNotificationBadge';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';
import { useNotificationsCounts } from 'src/hooks/useNotificationsCount';
import { useGetInboxNotificationsQuery } from 'src/services/api/inboxApi';
import { RootState } from 'src/store';

export const InboxNotificationBadge = () => {
  const { data: inboxNotifications } = useGetInboxNotificationsQuery();
  const cus = useSelector((state: RootState) => state.clients.clients);
  const ius = useSelector((state: RootState) => state.users.internalUsers);
  const companyDataMap = useSelector(
    (state: RootState) => state.clients.companyDataMap,
  );
  const { unreadNotificationCount } = useNotificationsCounts(
    inboxNotifications || [],
    [...cus, ...ius],
    companyDataMap,
  );

  const { backgroundColor, textColor } = useNotificationBadgeData(true);

  return (
    <SidebarNotificationBadge
      showZero={false}
      content={unreadNotificationCount}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
